import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const activationConfirmMessage = (
  record,
  intl,
  checked,
  name,
  category,
  onOkPressed,
  modal
) => {
  const checkedTitleId = "app." + category + ".freezeTitle";
  const freezeTitleId = "app." + category + ".freezeTitle";
  const activateContentId = "app.forms." + category + ".activateConfirmContent";
  const freezeContentId = "app.forms." + category + ".freezeConfirmContent";

  const title = checked
    ? intl.formatMessage({
        id: checkedTitleId,
      })
    : intl.formatMessage({
        id: freezeTitleId,
      });

  const content = checked
    ? intl.formatMessage({
        id: activateContentId,
      }) +
      " " +
      name
    : intl.formatMessage({
        id: freezeContentId,
      }) +
      " " +
      name;

  modal.confirm({
    title: title,
    icon: <ExclamationCircleOutlined />,
    content: content,
    onOk() {
      return onOkPressed(record);
    },
    onCancel() {},
  });
};

const deleteConfirmMessage = (intl, name, category, id, onOkPressed, modal) => {
  const title = intl.formatMessage({
    id: "app.forms." + category + ".deleteConfirmTitle",
  });
  const content =
    intl.formatMessage({
      id: "app.forms." + category + ".deleteConfirmContent",
    }) +
    " " +
    name +
    "?";
  modal.confirm({
    title: title,
    icon: <ExclamationCircleOutlined />,
    content: content,
    onOk() {
      return onOkPressed(id);
    },
    onCancel() {},
  });
};

const unsavedChangesConfirmMessage = ({ intl, modal, ...rest }) => {
  const title = intl.formatMessage({
    id: "app.forms.unSavedChangesTitle",
  });
  const content = intl.formatMessage({
    id: "app.forms.unSavedChangesContent",
  });
  return modal.confirm({
    title: title,
    icon: <ExclamationCircleOutlined />,
    content: content,
    autoFocusButton: "cancel",
    cancelText: intl.formatMessage({
      id: "app.forms.unSavedChangesCancelText",
    }),
    okText: intl.formatMessage({
      id: "app.forms.unSavedChangesOkText",
    }),
    ...rest,
  });
};

export {
  activationConfirmMessage,
  deleteConfirmMessage,
  unsavedChangesConfirmMessage,
};
